import React from "react";

const RatingTable = ({
  label,
  tableHeaders,
  questions,
  onChangeHandler,
  inputsData,
  inputsValidationData,
}) => {
  return (
    <>
      <div className="tps-form-question">
        {!!label && label !== "" && <h3>{label}</h3>}

        <table className="tps-form-rating-table" role="presentation">
          <tbody>
            <tr className="tps-form-rating-table-header">
              <td className="padded">&nbsp;</td>
              <td>
                <div className="table-scroll">
                  <table role="presentation">
                    <tbody>
                      <tr>
                        {tableHeaders.map((header, index) => (
                          <td
                            className="padded"
                            dangerouslySetInnerHTML={{ __html: header.header }}
                            key={index}
                          />
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
            {questions.map((question, index) => (
              <tr
                className="tps-form-rating-table-row"
                key={`${question.name}${index}`}
              >
                <td>
                  <div className="tps-form-label">
                    <span
                      className={`EditingFormLabel ${
                        question.required && "tps-field-required"
                      }`}
                      dangerouslySetInnerHTML={{ __html: question.label }}
                    ></span>
                  </div>

                  {!inputsValidationData[question.name]?.valid &&
                    question.required && (
                      <span className={"EditingFormErrorLabel"}>
                        {inputsValidationData[question.name]?.message}
                      </span>
                    )}
                </td>
                <td>
                  <div className="EditingFormControlNestedControl editing-form-control-nested-control">
                    <div className="table-scroll">
                      <table className="radio">
                        <tbody>
                          <tr>
                            {question.items.map((item, i) => (
                              <td key={`${question.name}-option${i}`}>
                                <input
                                  type="radio"
                                  id={`${question.name}-option${i}`}
                                  name={question.name}
                                  value={item.value}
                                  className="tps-to-validate"
                                  onChange={(event) => onChangeHandler(event)}
                                  checked={
                                    (inputsData[question.name] || "") ===
                                    item.value
                                  }
                                />
                                <label
                                  htmlFor={`${question.name}-option${i}`}
                                  dangerouslySetInnerHTML={{
                                    __html: item.label || item.value,
                                  }}
                                ></label>
                              </td>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default RatingTable;
